import { supabaseClient } from '@/lib/_utils/supabase/client';
import { StateCreator } from 'zustand';
import { User } from '@supabase/supabase-js';

export type WalletStore = {
	balance: number;
	isBalanceHidden: boolean;
	setIsBalanceHidden: (state: boolean) => void;
	getBalance: (user?: User | null) => void;
	isLoading: boolean;
	isModalWalletDepositOpen: boolean;
	setIsModalWalletDepositOpen: (state: boolean) => void;
};

export const createWalletSlice: StateCreator<WalletStore> = (set) => ({
	balance: 0,
	isBalanceHidden: false,
	setIsBalanceHidden: async (store) => {
		set(() => ({ isBalanceHidden: store }));
		if (store) {
			localStorage.setItem('isBalanceHidden', 'true');
		} else {
			localStorage.removeItem('isBalanceHidden');
		}
	},
	getBalance: async (user) => {
		set(() => ({ isLoading: true }));
		const userId = user ? user?.id : (await supabaseClient.auth.getSession()).data.session?.user?.id;

		const { data, error } = await supabaseClient
			.from('identities')
			.select('balance')
			.eq('id', userId ?? '')
			.single();

		set(() => ({ balance: data?.balance ?? 0 }));
		set(() => ({ isLoading: false }));
	},
	isLoading: false,
	isModalWalletDepositOpen: false,
	setIsModalWalletDepositOpen: (state) => set(() => ({ isModalWalletDepositOpen: state })),
});
